import React, { Component } from 'react'
import { Form, Input, Button, Table, Icon, message } from 'antd'
import "../styles/editStation.css"

import { editDocument } from "../redux/actions/Firebase"
import { getDocumentInfo, updateStation } from "../redux/actions/Stations"

import { bindActionCreators } from "redux";
import { connect } from 'react-redux';

import { styleEditStation } from '../styles/styles'

import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';

class editStation extends Component {

    constructor(props) {
        super(props)
        this.state = {
            position: [25.666202, -100.314178],
            number_slots: 0,
            date: "2017/06/18",
            changeAvailable: [],
            slots: [],
            columns: [
                {
                    title: 'Id',
                    dataIndex: 'number',
                    key: 'number',
                    align: 'center'
                },
                {
                    title: 'Disponible',
                    dataIndex: 'available',
                    key: 'available',
                    align: 'center',
                    render: (value, record, key) => {
                        var toChange = this.state.changeAvailable.indexOf(key) !== -1
                        if ((value === true && toChange === false) || (value === false && toChange === true)) {
                            return (
                                <Icon type="check-circle" theme="filled" style={{ color: "#3dd84c" }} onClick={() => this.editAvailable(key)} />
                            )
                        } else {
                            return (
                                <Icon type="close-circle" theme="filled" style={{ color: "#fb1d1d" }} onClick={() => this.editAvailable(key)} />
                            )
                        }
                    }
                },
                {
                    title: 'Cargando',
                    dataIndex: 'charging',
                    key: 'charging',
                    align: 'center',
                    render: (value) => {
                        if (value) {
                            return (
                                <Icon type="check-circle" theme="filled" style={{ color: "#3dd84c" }} />
                            )
                        } else {
                            return (
                                <div>
                                    <Icon type="close-circle" theme="filled" style={{ color: "#fb1d1d" }} />
                                </div>
                            )
                        }
                    }
                },
                {
                    title: 'Empresa',
                    dataIndex: 'vehicle',
                    key: 'vehicle',
                    align: 'center'
                },
            ]
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()
        var data = {actual: this.props.onEditionDocument, updated: this.state};
        this.props.updateStation(data);
        message.success("Estacion actualizada")
        this.props.history.goBack();
    }

    editAvailable = (index) => {
        if (this.state.changeAvailable.indexOf(index) === -1) {
            //No nos sirve usar push porque no regresa el arreglo
            var new_av = this.state.changeAvailable.concat(index)
            this.setState({ changeAvailable: new_av })
        } else {
            var filtered = this.state.changeAvailable.filter((value, key, arr) => {
                return value !== index
            })
            this.setState({ changeAvailable: filtered })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        var pos = this.props.onEditionDocument.position
        if (pos) {
            if (this.props.onEditionDocument.position !== prevProps.onEditionDocument.position) {
                this.setState({ position: [pos[0], pos[1]], date: this.props.onEditionDocument.date })
                this.forceUpdate()
            }
        }
    }

    render() {
        var slots = Object.values(this.props.onEditionDocument.slots)
        slots = slots.map((value, key) => ({...value, number: key}))

        return (
            <div className="bodyDivEdit" style={styleEditStation.mainDiv}>
                <h1>Edit Station</h1>
                <div>
                    <Form layout="inline" onSubmit={this.handleSubmit}>
                        <Form.Item>
                            <Input
                                size="large"
                                placeholder={this.props.onEditionDocument.position}
                                value = {this.state.position}
                                onChange={event => this.setState({ position: event.target.value })}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Input
                                placeholder={this.props.onEditionDocument.slots.length}
                                onChange={event => this.setState({ number_slots: event.target.value })}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Input
                                placeholder={this.props.onEditionDocument.date}
                                onChange={event => this.setState({ date: event.target.value })}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Editar
                        </Button>
                        </Form.Item>
                    </Form>
                </div>
                <h2 style={{paddingTop: 20, marginBottom: 0}}>Slots</h2>
                <Table dataSource={slots} columns={this.state.columns} style={styleEditStation.slotsTable} rowKey="number"/>
                <div style={styleEditStation.mapStyle}>

                    <Map
                        google={this.props.google}
                        zoom={13}
                        style={{ width: '80%', height: 760 }}
                        initialCenter={{
                            lat: 25.666202, 
                            lng: -100.314178
                        }}
                        onClick={(props, data, e) => this.setState({position: [e.latLng.lat(), e.latLng.lng()]})}
                    >
                        
                        <Marker 
                            position={{
                                lat: this.state.position[0],
                                lng: this.state.position[1],
                            }}
                        />

                    </Map>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        firebase: state.firebase,
        stationsCollection: state.firebase.stationsCollection,
        onEditionDocument: state.stations.onEditionDocument,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ editDocument, getDocumentInfo, updateStation }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(
    GoogleApiWrapper({
        apiKey: "AIzaSyBRt5tonSSUXJvKCIu4eZhDsjn8mEMOMl8"
    })(editStation)
)
